import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { WhiteListOrBlackListIpModal } from 'src/modules/features/setting/modals/app-security-modals/whitelistOrBlackListIpAddress/whitelistOrBlackListIpAddress.component';

@Component({
  selector: 'app-logs-row',
  templateUrl: './logs-row.component.html',
  styleUrls: ['./logs-row.component.scss'],
})
export class LogsRowComponent implements OnChanges {
  constructor(private modalSvc: SuiModalService) {}
  @Input() log: any = {};
  @Output() reload = new EventEmitter();
  @Output() pending = new EventEmitter();
  @Output() error = new EventEmitter();
  @Output() success = new EventEmitter();

  isIpBlackListed = this.log?.blacklistedIpId ? true : false;

  whiteListOrBlackListIp(data: any) {
    this.modalSvc
      .open(new WhiteListOrBlackListIpModal(data.title, data))
      .onApprove((modalData: any) => {
        if (modalData?.success) {
          this.success.emit(modalData?.message);
        }
        this.reload.emit(true);
      })
      .onDeny(() => {
        this.isIpBlackListed = this.log?.blacklistedIpId ? true : false;
      });
  }

  blackListToogleButtonClick() {
    if (this.log.blacklistedIpId) {
      //already black listed
      this.whiteListOrBlackListIp({
        ...this.log,
        title: 'Whitelist Ip',
        operation: 'whitelist',
      });
    } else {
      this.whiteListOrBlackListIp({
        ...this.log,
        title: 'Blacklist Ip',
        operation: 'blacklist',
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.log) {
      this.isIpBlackListed =
        changes['log'].currentValue.blacklistedIpId !== '' &&
        changes['log'].currentValue.blacklistedIpId !== null
          ? true
          : false;
    }
  }
}
